import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from '@chakra-ui/react';
import { useTranslation } from 'helpers/languages/translations';
import { TProductDetailsHooks } from '../../useProductDetails';

interface IProps {
    isDeleteOpen: TProductDetailsHooks['isDeleteOpen'];
    handleCloseDelete: TProductDetailsHooks['handleCloseDelete'];
    isDeleteLoading: TProductDetailsHooks['isDeleteLoading'];
    handleDeletePDPs: TProductDetailsHooks['handleDeletePDPs'];
    isDeleteMultiple: TProductDetailsHooks['isDeleteMultiple'];
    deleteInitialRef: TProductDetailsHooks['deleteInitialRef'];
}

const PDPModal = ({
    isDeleteOpen,
    handleCloseDelete,
    isDeleteLoading,
    handleDeletePDPs,
    isDeleteMultiple,
    deleteInitialRef,
}: IProps) => {
    const translate = useTranslation();
    return (
        <Modal isCentered initialFocusRef={deleteInitialRef} isOpen={isDeleteOpen} onClose={handleCloseDelete}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader tabIndex={-1} ref={deleteInitialRef}>
                    <Text as="h3">
                        {translate(
                            isDeleteMultiple
                                ? 'pdp.modal.titleDeleteMultiple'
                                : 'pdp.modal.titleDeleteSingle',
                        )}
                    </Text>
                </ModalHeader>
                <ModalCloseButton mt="2" isDisabled={isDeleteLoading} />
                <ModalBody fontSize="sm">
                    <Text>{translate('modal.deleteInfo')}</Text>
                </ModalBody>
                <ModalFooter>
                    <Button isDisabled={isDeleteLoading} variant="outline" size="sm" mr={3} onClick={handleCloseDelete}>
                        {translate('modal.cancel')}
                    </Button>
                    <Button
                        onClick={handleDeletePDPs}
                        isLoading={isDeleteLoading}
                        colorScheme="red"
                        size="sm"
                    >
                        {translate('modal.deleteAction')}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default PDPModal;
